import actionTypes from "@actionTypes";

const initialState = {
  user: {},
  isAuth: false,
  isLogging: false,
  isLoginSuccess: false,
  isLoginError: false,
  logoutMsg: "",
  isLoadingLogout: false,
  isLogoutSuccess: false,
  loginErrorMsg: "",
};

const reducer = (state = initialState, { type, payload } = {}) => {
  switch (type) {
    case actionTypes.AUTH_CHECK:
      return {
        ...state,
        user: payload.user,
        isAuth: payload.success,
        isLogging: false,
        isLoginSuccess: payload.success,
        isLoginError: false,
        isLogoutSuccess: false,
        loginErrorMsg: "",
      };

    case actionTypes.DO_LOGIN:
      return {
        ...state,
        isLogging: true,
        isLoginError: false,
        loginErrorMsg: "",
        isLogoutSuccess: false,
      };
    case actionTypes.DO_LOGIN_SUCCESS:
      return {
        ...state,
        user: payload.data,
        isAuth: payload.success,
        isLogging: false,
        isLoginSuccess: payload.success,
        isLoginError: false,
        loginErrorMsg: "",
      };
    case actionTypes.DO_LOGIN_FAILED:
      return {
        user: {},
        isAuth: false,
        isLogging: false,
        isLoginSuccess: false,
        isLoginError: true,
        loginErrorMsg: payload.error,
      };

    /* logout */
    case actionTypes.DO_LOGOUT:
      return { ...state, isLoadingLogout: true };
    case actionTypes.DO_LOGOUT_SUCCESS:
      return { ...initialState, isLogoutSuccess: true, isLoadingLogout: false };
    case actionTypes.DO_LOGOUT_FAILED:
      return {
        ...state,
      };
    default:
      return state;
  }
};

export const getAuth = (state) => state.auth.isAuth;
export default reducer;
